import React from "react";
import "./WorkWithUS.css";

export default function WorkWithUS({ currentLanguage = "en" }) {
  const isFrench = currentLanguage === "fr";

  // ================= ENGLISH DATA =================
  const dataEN = {
    title: "ABOUT WORKING WITH US",
    description: "At Pestel & Partners, we believe that our people are our greatest asset. We foster an environment where ambitious professionals can thrive, innovate, and make meaningful contributions to our clients' success. Our commitment to professional development, collaborative culture, and work-life balance creates the perfect foundation for building exceptional careers in accounting and consulting.",
    features: [
      {
        icon: "/assets/images/Career/team.png",
        alt: "team",
        title: "Expert Team",
        description: "Work alongside industry veterans and rising stars",
      },
      {
        icon: "/assets/images/Career/innovation.png",
        alt: "innovation",
        title: "Innovation",
        description: "Embrace cutting-edge technology and methodologies",
      },
      {
        icon: "/assets/images/Career/trophy.png",
        alt: "excellence",
        title: "Excellence",
        description: "Committed to delivering exceptional results",
      },
    ],
  };

  // ================= FRENCH DATA =================
  const dataFR = {
    title: "À PROPOS DE TRAVAILLER AVEC NOUS",
    description: "Chez Pestel & Partners, nous croyons que nos employés sont notre plus grand atout. Nous favorisons un environnement où les professionnels ambitieux peuvent s'épanouir, innover et apporter une contribution significative au succès de nos clients. Notre engagement envers le développement professionnel, la culture collaborative et l'équilibre travail-vie personnelle crée la base parfaite pour bâtir des carrières exceptionnelles en comptabilité et en conseil.",
    features: [
      {
        icon: "/assets/images/Career/team.png",
        alt: "équipe",
        title: "Équipe d'experts",
        description: "Travaillez aux côtés de vétérans de l'industrie et d'étoiles montantes",
      },
      {
        icon: "/assets/images/Career/innovation.png",
        alt: "innovation",
        title: "Innovation",
        description: "Adoptez les technologies et méthodologies de pointe",
      },
      {
        icon: "/assets/images/Career/trophy.png",
        alt: "excellence",
        title: "Excellence",
        description: "Engagés à fournir des résultats exceptionnels",
      },
    ],
  };

  // ================= SELECT LANGUAGE =================
  const data = isFrench ? dataFR : dataEN;
  const { title, description, features } = data;

  return (
    <div className="career-intro-wrapper">
      <div className="container text-center">

        {/* Heading */}
        <h2 className="career-title">{title}</h2>

        {/* Subtitle paragraph */}
        <p className="career-desc">{description}</p>

        {/* Icons Row */}
        <div className="row justify-content-center mt-4">

          {features.map((feature, idx) => (
            <div className="col-lg-3 col-md-4 col-sm-6 career-box" key={idx}>
              <div className="career-icon">
                <img src={feature.icon} alt={feature.alt} />
              </div>
              <h5 className="career-box-title">{feature.title}</h5>
              <p className="career-box-desc">{feature.description}</p>
            </div>
          ))}

        </div>
      </div>
    </div>
  );
}